'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require('../SvgIcon');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Close = function Close(props) {
	return _react2.default.createElement(
		_SvgIcon.SvgIcon,
		_extends({ viewBox: '0 0 26 26' }, props),
		_react2.default.createElement('path', { d: 'M6.656 4c-.29 0-.55.113-.75.313L4.313 5.905c-.4.4-.4 1.094 0 1.594l5.5 5.5-5.5 5.5c-.4.5-.4 1.195 0 1.594l1.593 1.593c.5.4 1.196.4 1.594 0l5.5-5.5 5.5 5.5c.5.4 1.195.4 1.594 0l1.593-1.593c.4-.5.4-1.196 0-1.594l-5.5-5.5 5.5-5.5c.4-.5.4-1.195 0-1.594l-1.593-1.593c-.5-.4-1.196-.4-1.594 0l-5.5 5.5-5.5-5.5C7.25 4.112 6.945 4 6.656 4z' })
	);
};

exports.default = Close;